module.exports = __webpack_public_path__ + "img/section4Content6.5713496b.png";